<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 6.75C8.41421 6.75 8.75 7.08579 8.75 7.5V11C8.75 11.4142 8.41421 11.75 8 11.75C7.58579 11.75 7.25 11.4142 7.25 11V7.5C7.25 7.08579 7.58579 6.75 8 6.75Z"
      fill="#868D9C"
    />
    <path
      d="M8 4C8.41421 4 8.75 4.33579 8.75 4.75C8.75 5.16421 8.41421 5.5 8 5.5C7.58579 5.5 7.25 5.16421 7.25 4.75C7.25 4.33579 7.58579 4 8 4Z"
      fill="#868D9C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5Z"
      fill="#868D9C"
    />
  </svg>
</template>
